import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { isExternalLink, createMarkup } from '../../shared/utility.js';
import classes from './CallToAction.module.scss';
import { IconExternalLink } from '@tabler/icons-react';

const callToAction = (props) => {
    let ctaLink = null;
    let copy = `Dies ist ein Typoblindtext. An ihm kann man sehen, ob alle Buchstaben da sind und wie sie aussehen.
                Manchmal benutzt man Worte wie Hamburgefonts, Rafgenduks oder Handgloves, um Schriften.`;

    // Todo: Refactor buttonText Prop to linkText because text links for external sites have been added
    if (props.buttonVisibility && props.linkUrl && props.buttonText) {
        if (isExternalLink(props.linkUrl)) {
            ctaLink = (
                <Button
                    outline={props.outline}
                    className={`mt-auto btn-block btn-md-inline-block ${props.btnClass}`}
                    color={props.buttonColor || 'secondary'}
                    href={props.linkUrl + '/'}
                    target="_blank"
                    rel="external noopener"
                >
                    {props.buttonText}
                    <IconExternalLink size={24} className="ms-1" />
                </Button>
            );
        } else {
            ctaLink = (
                <Button
                    outline={props.outline}
                    className={`mt-auto btn-block btn-md-inline-block ${props.btnClass}`}
                    color={props.buttonColor || 'secondary'}
                    tag={Link}
                    to={props.linkUrl + '/'}
                >
                    {props.buttonText}
                </Button>
            );
        }
    }

    // Replace copy text placeholder with prop value if passed by parent
    if (props.copy) {
        copy = props.copy;
    }

    return (
        <>
            <h2 className={props.bootstrapClass}>{props.headline}</h2>
            <p
                className={[classes.CallToAction, props.bootstrapClass].join(' ')}
                dangerouslySetInnerHTML={createMarkup(copy)}
            />
            {ctaLink}
        </>
    );
};

export default callToAction;
